exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".RjJ-L{margin:0 auto}._1N1iB{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}._2xu7G{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}._2OiFB{width:300px}._2OiFB,.nFKD3{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.nFKD3{width:calc(100% - 300px);padding-right:20px;position:relative}._2bKrm,._1770o{margin-bottom:20px}._2bKrm{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:0 45px}._2bKrm .adunitContainer>*{margin-bottom:10px}", ""]);

// exports
exports.locals = {
	"page": "_1pw5C page",
	"container": "RjJ-L container",
	"flexRow": "_1N1iB flexRow",
	"flexGrow1": "_2xu7G",
	"sideBar": "_2OiFB",
	"mainCell": "nFKD3",
	"gptPremium": "_1770o",
	"mainCellAds": "_2bKrm"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/routes/advert/Advert.css
// module id = 3313
// module chunks = 32